function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "markdown", "citationPrefix", "linkType", "citationsList"],
  _excluded2 = ["_id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useCallback } from 'react';
import styled from 'styled-components';
import { getAppearanceConstant, grey3, highlightGrey, setAppearanceConstantLocal, spacing16 } from '@churchofjesuschrist/eden-style-constants';
import { Markdown } from '@churchofjesuschrist/eden-markdown';
import { commonMessageStyles } from "./messageStyles.mjs";
import { useCitations, withCitations } from "./CitationsContext.mjs";
import Citation from "./Citation.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var highlightGreyLight = getAppearanceConstant(highlightGrey).light;
var _setAppearanceConstan = setAppearanceConstantLocal('receiver-color', {
    light: grey3,
    dark: highlightGreyLight
  }),
  _setAppearanceConstan2 = _slicedToArray(_setAppearanceConstan, 2),
  receiverColorDef = _setAppearanceConstan2[0],
  receiverColor = _setAppearanceConstan2[1];
var MessageContainer = styled.div.withConfig({
  componentId: "sc-366y5h-0"
})(["", " ", ";background-color:", ";align-self:flex-start;border-start-start-radius:2px;"], commonMessageStyles, receiverColorDef, receiverColor);
var CitationsList = styled.ol.withConfig({
  componentId: "sc-366y5h-1"
})(["list-style:inside numeric;margin:0;&&{padding:0;}margin-top:", ";"], spacing16);

/**
 * @typedef {object} Props
 * @property {React.ReactNode} children Message content.
 * @property {boolean} [markdown] Whether to parse `children` as markdown. Defaults to `true`.
 * @property {string} [citationPrefix]
 *
 * If a link's href starts with `citationPrefix`, it will be treated as a citation, and will be displayed as a citation number instead of as the link text.
 * Link text will be used in the citations list at the bottom of the message.
 *
 * If `citaionPrefix` is omitted, all links will be treated as citations.
 *
 * If `markdown` is false, this prop is ignored.
 * @property {React.ComponentType} [linkType] The component to use for links in chatbot messages. Defaults to an anchor tag.
 * @property {boolean} [citationsList] Whether to show the citations list at the bottom of the message. Defaults to `true`.
 */

var ReceivedMessage = withCitations(
/**
 * @param {Props} props
 */
function (_ref) {
  var children = _ref.children,
    _ref$markdown = _ref.markdown,
    markdown = _ref$markdown === void 0 ? true : _ref$markdown,
    citationPrefix = _ref.citationPrefix,
    LinkType = _ref.linkType,
    _ref$citationsList = _ref.citationsList,
    citationsList = _ref$citationsList === void 0 ? true : _ref$citationsList,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useCitations = useCitations(),
    citations = _useCitations.citations;

  // Have to nest this because we need the citationPrefix prop. useCallback is preventing extra renders.
  var WrappedCitation = useCallback(
  // eslint-disable-next-line @eslint-react/no-nested-components
  function (props) {
    return /*#__PURE__*/_jsx(Citation, _objectSpread(_objectSpread({}, props), {}, {
      citationPrefix: citationPrefix,
      linkType: LinkType
    }));
  }, [LinkType, citationPrefix]);
  return /*#__PURE__*/_jsxs(MessageContainer, _objectSpread(_objectSpread({
    "data-scroll": true
  }, rest), {}, {
    children: [markdown ? /*#__PURE__*/_jsx(Markdown, {
      components: {
        a: WrappedCitation
      },
      children: children
    }) : children, (citations === null || citations === void 0 ? void 0 : citations.length) > 0 && citationsList && /*#__PURE__*/_jsx(CitationsList, {
      "data-testid": "citations",
      children: citations.map(function (_ref2) {
        var _id = _ref2._id,
          citation = _objectWithoutProperties(_ref2, _excluded2);
        return /*#__PURE__*/_jsx("li", {
          children: LinkType ? /*#__PURE__*/_jsx(LinkType, _objectSpread(_objectSpread({
            href: citation.href
          }, citation), {}, {
            children: citation.children
          })) : /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
            rel: "noreferrer noopener",
            target: "_blank"
          }, citation), {}, {
            children: citation.children
          }))
        }, _id);
      })
    })]
  }));
});
export default ReceivedMessage;